import types from "./types";

export default {
  [types.AUTH_SET]: function(state, payload) {
    state.isLoggedIn = true;
    state.user = payload.user;
    state.userToken = payload.jwt;
  },
  [types.AUTH_UNSET]: function(state) {
    state.isLoggedIn = false;
    state.user = null;
    state.userToken = null;
  },
  [types.AUTH_SET_COOKIE]: function(state, payload) {
    state.user = payload.user;
  },
  [types.AUTH_CHECK]: function() {
    return null;
  },
  [types.AUTH_STATE]: function(state, payload) {
    state.isAuthenticated = payload.isAuthenticated;
  },
  [types.AUTH_SET_ERRORS]: function(state, payload) {
    state.errors = payload;
  }
};
